import { SelectItem } from "primeng/api";
import { PostNewCashInvoiceStatus } from "../enums";

export class PostNewCashInvoiceStatusLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'In-Active', value: PostNewCashInvoiceStatus.InActive },
            { label: 'Issue', value: PostNewCashInvoiceStatus.Issue },
            { label: 'Manual', value: PostNewCashInvoiceStatus.Manual },
        ];
    }
}